export default "__VITE_ASSET__2e026878__"